import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider,Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import css from './index.css';

const baseUrlPath = "/fwwgl/zzbd";


class FlpzForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
        };
    }

    updateSingleFlpzBtState=(record)=>{
        let pkid = record.PKID==undefined?null:record.PKID;
        let flbs = record.FLBS;
        let sfbt = record.SFBT=='1'?'0':'1';
        let sfxs = record.SFXS;
        this.updateFlpzState(pkid,flbs,sfbt,sfxs);
    }

    updateSingleFlpzXsState=(record)=>{
        let pkid = record.PKID==undefined?null:record.PKID;
        let flbs = record.FLBS;
        let sfbt = record.SFBT;
        let sfxs = record.SFXS=='1'?'0':'1';
        this.updateFlpzState(pkid,flbs,sfbt,sfxs);
    }

    updateFlpzState = (pkid,flbs,sfbt,sfxs) => {
        NHFetch(baseUrlPath+"/saveOrUpdateFlpz","POST",{"pkid":pkid,"flbs":flbs,"sfbt":sfbt,"sfxs":sfxs,})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("设置成功");
                }else{
                    message.warn("设置异常");
                }
                this.refs.nhTable.readTableData();
            });
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                width: '70',
                dataIndex: 'ROW_ID'
            }, {
                title: '分类标识',
                width: '150',
                dataIndex: 'FLBS',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '分类名称',
                width: '200',
                dataIndex: 'FLMC',
                render:(text,record,index)=>{
                    return (text && text.length>10)?<Tooltip title={text}>{text.substring(0,10)+"..."}</Tooltip>:text;
                },
                searchType:"input"
            }, {
                title: '是否必填',
                width: '110',
                dataIndex: 'SFBTMC',
                fixed:'right',
                render:(text,record,index) => {
                    const status=record.SFBT=='1'?true:false;
                    const sfbtmc = ['否','是'];
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_xxfb:updateFbztState')?
                            <Switch checkedChildren={sfbtmc[1]} unCheckedChildren={sfbtmc[0]} checked={status} onChange={() => this.updateSingleFlpzBtState(record)}/>:
                            <span>{status?sfbtmc[1]:sfbtmc[0]}</span>
                    );
                },
                searchType:"select"
            }, {
                title: '是否显示',
                width: '100',
                dataIndex: 'SFXSMC',
                fixed:'right',
                render:(text,record,index) => {
                    const status=record.SFXS=='1'?true:false;
                    const sfxsmc = ['否','是'];
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_xxfb:updateZdztState')?
                            <Switch checkedChildren={sfxsmc[1]} unCheckedChildren={sfxsmc[0]} checked={status} onChange={() => this.updateSingleFlpzXsState(record)}/>:
                            <span>{status?sfxsmc[1]:sfxsmc[0]}</span>
                    );
                },
                searchType:"select"
            }
        ];
        
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:'block'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID}
                             sign={"zhxg_yxxt_fwwgl_zzbd_selectFlpz"}
                             columns={columns}
                    >
                    </NHTable>
                </div>
                
            </div>
        );
    }
}
export default FlpzForm;



// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/FlpzForm.js